function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var iconData = [{
  name: 'notification-solid',
  unicode: '&#xe900;',
  deprecatedNames: ['alert-solid'],
  category: 'system'
}, {
  name: 'notification',
  unicode: '&#xe901;',
  deprecatedNames: ['alert'],
  category: 'system'
}, {
  name: 'attach',
  unicode: '&#xe902;',
  category: 'system'
}, {
  name: 'error-execute',
  unicode: '&#xe903;',
  deprecatedNames: ['cancel'],
  category: 'system'
}, {
  name: 'bar-chart',
  unicode: '&#xe904;',
  deprecatedNames: ['chart'],
  category: 'system'
}, {
  name: 'line-chart',
  unicode: '&#xe905;',
  deprecatedNames: ['charline', 'chartline'],
  category: 'system'
}, {
  name: 'line-chart-solid',
  unicode: '&#xe906;',
  deprecatedNames: ['charline-solid', 'chartline-solid'],
  category: 'system'
}, {
  name: 'chatting-solid',
  unicode: '&#xe907;',
  deprecatedNames: ['chat-busy-solid'],
  category: 'system'
}, {
  name: 'chatting',
  unicode: '&#xe908;',
  deprecatedNames: ['chat-busy'],
  category: 'system'
}, {
  name: 'chat-group-solid',
  unicode: '&#xe909;',
  category: 'system'
}, {
  name: 'chat-group',
  unicode: '&#xe90a;',
  category: 'system'
}, {
  name: 'chat-solid',
  unicode: '&#xe90b;',
  category: 'system'
}, {
  name: 'chat',
  unicode: '&#xe90c;',
  category: 'system'
}, {
  name: 'clone',
  unicode: '&#xe90d;',
  category: 'system'
}, {
  name: 'close',
  unicode: '&#xe90e;',
  category: 'system'
}, {
  name: 'column-chooser-solid',
  unicode: '&#xe90f;',
  deprecatedNames: ['column-chooser-single-solid'],
  category: 'system'
}, {
  name: 'column-chooser',
  unicode: '&#xe910;',
  deprecatedNames: ['column-chooser-single'],
  category: 'system'
}, {
  name: 'delete-solid',
  unicode: '&#xe911;',
  category: 'system'
}, {
  name: 'delete',
  unicode: '&#xe912;',
  category: 'system'
}, {
  name: 'document',
  unicode: '&#xe913;',
  category: 'system'
}, {
  name: 'add-document',
  unicode: '&#xe914;',
  deprecatedNames: ['document-add'],
  category: 'system'
}, {
  name: 'csv',
  unicode: '&#xe915;',
  deprecatedNames: ['document-csv'],
  category: 'system'
}, {
  name: 'pdf',
  unicode: '&#xe916;',
  deprecatedNames: ['document-pdf'],
  category: 'system'
}, {
  name: 'remove-document',
  unicode: '&#xe917;',
  deprecatedNames: ['document-remove'],
  category: 'system'
}, {
  name: 'run-report',
  unicode: '&#xe918;',
  deprecatedNames: ['document-run'],
  category: 'system'
}, {
  name: 'schedule-time',
  unicode: '&#xe919;',
  deprecatedNames: ['document-schedule-time'],
  category: 'system'
}, {
  name: 'xls',
  unicode: '&#xe91a;',
  deprecatedNames: ['document-xls'],
  category: 'system'
}, {
  name: 'chevron-down',
  unicode: '&#xe91b;',
  deprecatedNames: ['down-arrow'],
  category: 'system'
}, {
  name: 'edit',
  unicode: '&#xe91c;',
  category: 'system'
}, {
  name: 'edit-solid',
  unicode: '&#xe91d;',
  category: 'system'
}, {
  name: 'export-solid',
  unicode: '&#xe91e;',
  category: 'system'
}, {
  name: 'export',
  unicode: '&#xe91f;',
  category: 'system'
}, {
  name: 'favorite-solid',
  unicode: '&#xe920;',
  category: 'system'
}, {
  name: 'favorite',
  unicode: '&#xe921;',
  category: 'system'
}, {
  name: 'filter-solid',
  unicode: '&#xe922;',
  category: 'system'
}, {
  name: 'filter',
  unicode: '&#xe923;',
  category: 'system'
}, {
  name: 'flag-solid',
  unicode: '&#xe924;',
  category: 'system'
}, {
  name: 'flag',
  unicode: '&#xe925;',
  category: 'system'
}, {
  name: 'grid-solid',
  unicode: '&#xe926;',
  category: 'system'
}, {
  name: 'grid',
  unicode: '&#xe927;',
  category: 'system'
}, {
  name: 'user-group-solid',
  unicode: '&#xe928;',
  deprecatedNames: ['group-solid'],
  category: 'system'
}, {
  name: 'user-group',
  unicode: '&#xe929;',
  deprecatedNames: ['group'],
  category: 'system'
}, {
  name: 'help',
  unicode: '&#xe92a;',
  deprecatedNames: ['help-solid'],
  category: 'system'
}, {
  name: 'help-secondary',
  unicode: '&#xe92b;',
  category: 'system'
}, {
  name: 'home-solid',
  unicode: '&#xe92c;',
  category: 'system'
}, {
  name: 'home',
  unicode: '&#xe92d;',
  category: 'system'
}, {
  name: 'import-solid',
  unicode: '&#xe92e;',
  category: 'system'
}, {
  name: 'import',
  unicode: '&#xe92f;',
  category: 'system'
}, {
  name: 'info',
  unicode: '&#xe930;',
  deprecatedNames: ['info-solid'],
  category: 'status'
}, {
  name: 'info-secondary',
  unicode: '&#xe931;',
  category: 'status'
}, {
  name: 'price-ladder',
  unicode: '&#xe932;',
  deprecatedNames: ['ladder'],
  category: 'system'
}, {
  name: 'chevron-left',
  unicode: '&#xe933;',
  deprecatedNames: ['left-arrow'],
  category: 'system'
}, {
  name: 'double-chevron-left',
  unicode: '&#xe934;',
  deprecatedNames: ['left-expand'],
  category: 'system'
}, {
  name: 'linked',
  unicode: '&#xe935;',
  category: 'system'
}, {
  name: 'list',
  unicode: '&#xe936;',
  category: 'system'
}, {
  name: 'locked-solid',
  unicode: '&#xe937;',
  category: 'system'
}, {
  name: 'locked',
  unicode: '&#xe938;',
  category: 'system'
}, {
  name: 'maximize',
  unicode: '&#xe939;',
  deprecatedNames: ['maximise'],
  category: 'system'
}, {
  name: 'menu',
  unicode: '&#xe93a;',
  deprecatedNames: ['menu-burger'],
  category: 'system'
}, {
  name: 'message-solid',
  unicode: '&#xe93b;',
  category: 'system'
}, {
  name: 'message',
  unicode: '&#xe93c;',
  category: 'system'
}, {
  name: 'minimize',
  unicode: '&#xe93d;',
  deprecatedNames: ['minimise'],
  category: 'system'
}, {
  name: 'overflow-menu',
  unicode: '&#xe93e;',
  deprecatedNames: ['more'],
  category: 'system'
}, {
  name: 'arrow-down',
  unicode: '&#xe93f;',
  deprecatedNames: ['movement-down'],
  category: 'system'
}, {
  name: 'arrow-up',
  unicode: '&#xe940;',
  deprecatedNames: ['movement-up'],
  category: 'system'
}, {
  name: 'pause',
  unicode: '&#xe941;',
  category: 'system'
}, {
  name: 'call-solid',
  unicode: '&#xe942;',
  deprecatedNames: ['phone-solid'],
  category: 'system'
}, {
  name: 'call',
  unicode: '&#xe943;',
  deprecatedNames: ['phone'],
  category: 'system'
}, {
  name: 'pin-solid',
  unicode: '&#xe944;',
  category: 'system'
}, {
  name: 'pin',
  unicode: '&#xe945;',
  category: 'system'
}, {
  name: 'place-in',
  unicode: '&#xe946;',
  category: 'system'
}, {
  name: 'play-solid',
  unicode: '&#xe947;',
  category: 'system'
}, {
  name: 'play',
  unicode: '&#xe948;',
  category: 'system'
}, {
  name: 'print-solid',
  unicode: '&#xe949;',
  category: 'system'
}, {
  name: 'print',
  unicode: '&#xe94a;',
  category: 'system'
}, {
  name: 'redo',
  unicode: '&#xe94b;',
  category: 'system'
}, {
  name: 'undo',
  unicode: '&#xe94c;',
  category: 'system'
}, {
  name: 'refresh',
  unicode: '&#xe94d;',
  category: 'system'
}, {
  name: 'remove',
  unicode: '&#xe94e;',
  deprecatedNames: ['minus'],
  category: 'system'
}, {
  name: 'build-report',
  unicode: '&#xe94f;',
  deprecatedNames: ['report-builder'],
  category: 'system'
}, {
  name: 'chevron-right',
  unicode: '&#xe950;',
  deprecatedNames: ['right-arrow'],
  category: 'system'
}, {
  name: 'double-chevron-right',
  unicode: '&#xe951;',
  deprecatedNames: ['right-expand'],
  category: 'system'
}, {
  name: 'save-solid',
  unicode: '&#xe952;',
  category: 'system'
}, {
  name: 'save',
  unicode: '&#xe953;',
  category: 'system'
}, {
  name: 'search',
  unicode: '&#xe954;',
  category: 'system'
}, {
  name: 'settings-solid',
  unicode: '&#xe955;',
  category: 'system'
}, {
  name: 'settings',
  unicode: '&#xe956;',
  category: 'system'
}, {
  name: 'share-solid',
  unicode: '&#xe957;',
  category: 'system'
}, {
  name: 'share',
  unicode: '&#xe958;',
  category: 'system'
}, {
  name: 'swap',
  unicode: '&#xe959;',
  deprecatedNames: ['swap-switch'],
  category: 'system'
}, {
  name: 'tear-out',
  unicode: '&#xe95a;',
  category: 'system'
}, {
  name: 'success-tick',
  unicode: '&#xe95b;',
  deprecatedNames: ['tick'],
  category: 'system'
}, {
  name: 'clock-solid',
  unicode: '&#xe95c;',
  deprecatedNames: ['time-solid'],
  category: 'system'
}, {
  name: 'clock',
  unicode: '&#xe95d;',
  deprecatedNames: ['time'],
  category: 'system'
}, {
  name: 'unlinked',
  unicode: '&#xe95e;',
  category: 'system'
}, {
  name: 'unlocked-solid',
  unicode: '&#xe95f;',
  category: 'system'
}, {
  name: 'unlocked',
  unicode: '&#xe960;',
  category: 'system'
}, {
  name: 'chevron-up',
  unicode: '&#xe961;',
  deprecatedNames: ['up-arrow'],
  category: 'system'
}, {
  name: 'user-solid',
  unicode: '&#xe962;',
  category: 'system'
}, {
  name: 'user',
  unicode: '&#xe963;',
  category: 'system'
}, {
  name: 'visible-solid',
  unicode: '&#xe964;',
  category: 'system'
}, {
  name: 'visible',
  unicode: '&#xe965;',
  category: 'system'
}, {
  name: 'hidden',
  unicode: '&#xe966;',
  deprecatedNames: ['visible-off'],
  category: 'system'
}, {
  name: 'warning',
  unicode: '&#xe967;',
  deprecatedNames: ['warning-solid'],
  category: 'status'
}, {
  name: 'warning-secondary',
  unicode: '&#xe968;',
  category: 'status'
}, {
  name: 'micro-menu',
  unicode: '&#xe969;',
  deprecatedNames: ['more-vert'],
  category: 'system'
}, {
  name: 'user-badge',
  unicode: '&#xe96a;',
  deprecatedNames: ['user-circled'],
  category: 'system'
}, {
  name: 'cut',
  unicode: '&#xe96d;',
  category: 'system'
}, {
  name: 'folder-closed',
  unicode: '&#xe96e;',
  deprecatedNames: ['folder'],
  category: 'system'
}, {
  name: 'loader',
  unicode: '&#xe96f;',
  category: 'system'
}, {
  name: 'move-all',
  unicode: '&#xe970;',
  category: 'system'
}, {
  name: 'move-vertical',
  unicode: '&#xe971;',
  deprecatedNames: ['move-updown'],
  category: 'system'
}, {
  name: 'paste',
  unicode: '&#xe972;',
  category: 'system'
}, {
  name: 'add',
  unicode: '&#xe973;',
  deprecatedNames: ['plus'],
  category: 'system'
}, {
  name: 'sum-solid',
  unicode: '&#xe974;',
  deprecatedNames: ['sigma-solid'],
  category: 'system'
}, {
  name: 'sum',
  unicode: '&#xe975;',
  deprecatedNames: ['sigma'],
  category: 'system'
}, {
  name: 'tree',
  unicode: '&#xe976;',
  category: 'system'
}, {
  name: 'calendar',
  unicode: '&#xe977;',
  category: 'system'
}, {
  name: 'folder-open',
  unicode: '&#xe978;',
  category: 'system'
}, {
  name: 'pivot',
  unicode: '&#xe979;',
  category: 'system'
}, {
  name: 'arrow-left',
  unicode: '&#xe97a;',
  category: 'system'
}, {
  name: 'arrow-right',
  unicode: '&#xe97b;',
  category: 'system'
}, {
  name: 'double-chevron-down',
  unicode: '&#xe97c;',
  deprecatedNames: ['down-expand'],
  category: 'system'
}, {
  name: 'double-chevron-up',
  unicode: '&#xe97d;',
  deprecatedNames: ['up-expand'],
  category: 'system'
}, {
  name: 'upload',
  unicode: '&#xe97e;',
  category: 'system'
}, {
  name: 'download',
  unicode: '&#xe97f;',
  category: 'system'
}, {
  name: 'triangle-right',
  unicode: '&#xe980;',
  deprecatedNames: ['triangle-right-filled'],
  category: 'system'
}, {
  name: 'triangle-left',
  unicode: '&#xe981;',
  deprecatedNames: ['triangle-left-filled'],
  category: 'system'
}, {
  name: 'triangle-up',
  unicode: '&#xe982;',
  deprecatedNames: ['triangle-up-filled'],
  category: 'system'
}, {
  name: 'triangle-down',
  unicode: '&#xe983;',
  deprecatedNames: ['triangle-down-filled'],
  category: 'system'
}, {
  name: 'copy',
  unicode: '&#xe984;',
  category: 'system'
}, {
  name: 'error',
  unicode: '&#xe985;',
  deprecatedNames: ['error-solid'],
  category: 'status'
}, {
  name: 'error-secondary',
  unicode: '&#xe986;',
  category: 'status'
}, {
  name: 'commentary',
  unicode: '&#xe987;',
  category: 'system'
}, {
  name: 'pause-solid',
  unicode: '&#xe988;',
  category: 'system'
}, {
  name: 'success',
  unicode: '&#xe989;',
  category: 'status'
}, {
  name: 'success-secondary',
  unicode: '&#xe98a;',
  category: 'status'
}, {
  name: 'move-horizontal',
  unicode: '&#xe98b;',
  category: 'system'
}, {
  name: 'app-switcher',
  unicode: '&#xe98c;',
  category: 'system'
}, {
  name: 'close-small',
  unicode: '&#xe98d;',
  category: 'system'
}, {
  name: 'triangle-right-down',
  unicode: '&#xe98e;',
  category: 'system'
}, {
  name: 'send',
  unicode: '&#xe98f;',
  category: 'system'
}, {
  name: 'location',
  unicode: '&#xe990;',
  category: 'system'
}, {
  name: 'restore',
  unicode: '&#xe991;',
  category: 'system'
}, {
  name: 'thumbs-up',
  unicode: '&#xe992;',
  deprecatedNames: ['like'],
  category: 'system'
}, {
  name: 'thumbs-up-solid',
  unicode: '&#xe993;',
  deprecatedNames: ['like-solid'],
  category: 'system'
}, {
  name: 'thumbs-down',
  unicode: '&#xe994;',
  deprecatedNames: ['dislike'],
  category: 'system'
}, {
  name: 'thumbs-down-solid',
  unicode: '&#xe995;',
  deprecatedNames: ['dislike-solid'],
  category: 'system'
}, {
  name: 'globe',
  unicode: '&#xe996;',
  category: 'system'
}, {
  name: 'globe-solid',
  unicode: '&#xe997;',
  category: 'system'
}, {
  name: 'presentation-solid',
  unicode: '&#xe998;',
  category: 'system'
}, {
  name: 'presentation',
  unicode: '&#xe999;',
  category: 'system'
}, {
  name: 'note',
  unicode: '&#xe99a;',
  deprecatedNames: ['sticky'],
  category: 'system'
}, {
  name: 'note-solid',
  unicode: '&#xe99b;',
  deprecatedNames: ['sticky-solid'],
  category: 'system'
}, {
  name: 'guide-closed',
  unicode: '&#xe99c;',
  deprecatedNames: ['book-closed'],
  category: 'system'
}, {
  name: 'guide-open',
  unicode: '&#xe99d;',
  deprecatedNames: ['book-open'],
  category: 'system'
}, {
  name: 'storage-solid',
  unicode: '&#xe99e;',
  category: 'system'
}, {
  name: 'stackoverflow',
  unicode: '&#xe99f;',
  category: 'system'
}, {
  name: 'storage',
  unicode: '&#xe9a0;',
  category: 'system'
}, {
  name: 'protection-solid',
  unicode: '&#xe9a1;',
  deprecatedNames: ['shield-solid'],
  category: 'system'
}, {
  name: 'protection',
  unicode: '&#xe9a2;',
  deprecatedNames: ['shield'],
  category: 'system'
}, {
  name: 'dashboard',
  unicode: '&#xe9a3;',
  category: 'system'
}, {
  name: 'dashboard-solid',
  unicode: '&#xe9a4;',
  category: 'system'
}, {
  name: 'database',
  unicode: '&#xe9a5;',
  category: 'system'
}, {
  name: 'database-solid',
  unicode: '&#xe9a6;',
  category: 'system'
}, {
  name: 'inbox-solid',
  unicode: '&#xe9a7;',
  category: 'system'
}, {
  name: 'inbox',
  unicode: '&#xe9a8;',
  category: 'system'
}, {
  name: 'user-admin-solid',
  unicode: '&#xe9a9;',
  category: 'system'
}, {
  name: 'user-admin',
  unicode: '&#xe9aa;',
  category: 'system'
}, {
  name: 'symphony',
  unicode: '&#xe9ab;',
  category: 'system'
}, {
  name: 'zip',
  unicode: '&#xe9ac;',
  deprecatedNames: ['document-zip'],
  category: 'system'
}, {
  name: 'calendar-solid',
  unicode: '&#xe9ad;',
  category: 'system'
}, {
  name: 'document-solid',
  unicode: '&#xe9ae;',
  category: 'system'
}, {
  name: 'commentary-solid',
  unicode: '&#xe9af;',
  category: 'system'
}, {
  name: 'paste-solid',
  unicode: '&#xe9b0;',
  category: 'system'
}, {
  name: 'tree-solid',
  unicode: '&#xe9b1;',
  category: 'system'
}, {
  name: 'copy-solid',
  unicode: '&#xe9b2;',
  category: 'system'
}, {
  name: 'add-document-solid',
  unicode: '&#xe9b3;',
  category: 'system'
}, {
  name: 'remove-document-solid',
  unicode: '&#xe9b4;',
  category: 'system'
}, {
  name: 'step-default',
  unicode: '&#xe9b5;',
  category: 'system'
}, {
  name: 'step-active',
  unicode: '&#xe9b6;',
  category: 'system'
}, {
  name: 'step-success',
  unicode: '&#xe9b7;',
  category: 'system'
}, {
  name: 'bank-cheque-solid',
  unicode: '&#xe9b8;',
  deprecatedNames: ['bank-check-solid'],
  category: 'system'
}, {
  name: 'bank-cheque',
  unicode: '&#xe9b9;',
  deprecatedNames: ['bank-check'],
  category: 'system'
}, {
  name: 'credit-card-solid',
  unicode: '&#xe9ba;',
  category: 'system'
}, {
  name: 'credit-card',
  unicode: '&#xe9bb;',
  category: 'system'
}, {
  name: 'forward-30',
  unicode: '&#xe9bc;',
  category: 'system'
}, {
  name: 'forward-10',
  unicode: '&#xe9bd;',
  category: 'system'
}, {
  name: 'forward-15',
  unicode: '&#xe9be;',
  category: 'system'
}, {
  name: 'forward-5',
  unicode: '&#xe9bf;',
  category: 'system'
}, {
  name: 'replay-5',
  unicode: '&#xe9c0;',
  category: 'system'
}, {
  name: 'replay-10',
  unicode: '&#xe9c1;',
  category: 'system'
}, {
  name: 'replay-15',
  unicode: '&#xe9c2;',
  category: 'system'
}, {
  name: 'replay-30',
  unicode: '&#xe9c3;',
  category: 'system'
}, {
  name: 'volume-down',
  unicode: '&#xe9c4;',
  category: 'system'
}, {
  name: 'volume-up',
  unicode: '&#xe9c5;',
  category: 'system'
}, {
  name: 'volume-off',
  unicode: '&#xe9c6;',
  category: 'system'
}, {
  name: 'expand',
  unicode: '&#xe9c7;',
  category: 'system'
}];
export var deprecatedNames = iconData.flatMap(function (x) {
  return x.deprecatedNames || [];
});
export var names = iconData.map(function (x) {
  return x.name;
});
var KEBAB_RE = /-([a-z])/g;
var FIRST_LETTER_RE = /^(.)(.*)$/g;

var toTitleCase = function toTitleCase(name) {
  return name.replace(KEBAB_RE, function (s) {
    return s[1].toUpperCase();
  }).replace(FIRST_LETTER_RE, function (s) {
    return "".concat(s[0].toUpperCase()).concat(s.slice(1));
  });
};

var entityToUnicode = function entityToUnicode(entity) {
  return "\\".concat(entity.slice(3, -1));
};

var icon = iconData.reduce(function (obj, singleData) {
  var unicodeEntity = singleData.unicode;
  var allNames = [singleData.name].concat(_toConsumableArray(singleData.deprecatedNames || []));
  allNames.forEach(function (name) {
    obj["Icon".concat(toTitleCase(name))] = {
      '&:before': {
        content: "\"".concat(entityToUnicode(unicodeEntity), "\"")
      }
    };
  });
  return obj;
}, {});
export default icon;